// extracted by mini-css-extract-plugin
export default {"Box":"SubIssuesList-module__Box__tpZ9N3L","ButtonGroup":"SubIssuesList-module__ButtonGroup__N8wZ8GN"};